import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import styled from 'styled-components';
// import logo from '../../assets/logo.png'; // Importe sua logo aqui

const NotFound = () => {
    return (
        <PanelAuth>
            <BoxAuth>
                <LogoContainer>
                    {/* <img src={logo} alt="Logo Empiria" width={150} /> */}
                </LogoContainer>
                <Typography variant="h4" align="center" sx={{ marginBottom: 2, fontWeight: 600 }}>
                    404 - Página Não Encontrada
                </Typography>
                <Typography align="center" sx={{ marginBottom: 3, fontSize: '1.1rem', color: '#555' }}>
                    Desculpe, não conseguimos encontrar a página que você está procurando.
                </Typography>
                <Link to="/">
                    <StyledButton variant="contained">Voltar para a Página Inicial</StyledButton>
                </Link>
            </BoxAuth>
        </PanelAuth>
    );
};

export default NotFound;

const PanelAuth = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #eee;
`;

const BoxAuth = styled(Box)`
    border-radius: 1rem;
    padding: 2rem;
    width: 350px;
    background: white;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    text-align: center;
`;

const LogoContainer = styled.div`
    margin-bottom: 20px;
`;

const StyledButton = styled(Button)`
    width: 100%;
    padding: 12px;
    background-color: #2ecc71; /* Cor secundária */
    color: white;
    font-weight: 600;
    text-transform: none;
    border-radius: 8px;
    &:hover {
        background-color: #27ae60; /* Efeito de hover */
    }
`;
